<template>
	<v-template>
		<v-row>
			<v-col cols="12" class="display-1 text-center">
				Resumen
			</v-col>
			<v-col cols="12" class="">
				Por favor revisa que los datos <b>sean correctos y completos</b>. Son necesarios para generar el
				<b>contrato</b> definitivo, para que podamos <b>contactarte</b> y para <b>enviarte de los puntos de
				venta</b> (en caso de haber elegido un plan que los incluya).
			</v-col>
		</v-row>
		<v-card outlined color="grey lighten-4" class="pa-2 my-3">
			<v-row dense>
				<v-col cols="12" class="title">
					Plan a contratar
					<v-btn @click="cambiarPaso(indicePasoPlan)" color="primary" fab x-small dark depressed>
						<v-icon>
							mode_edit
						</v-icon>
					</v-btn>
				</v-col>
				<v-col cols="12" :md="hayDatosAdicionales ? 4 : 6" class="d-flex justify-center align-center flex-column">
					<v-img :src="plan.urlAvatar" max-height="120" contain eager v-if="plan.urlAvatar"/>
					<div class="text-center">
						<div class="py-1 headline font-weight-black">
							{{ plan.nombre }}
						</div>
						<div class="py-1 font-weight-black">
							{{ cantidad }} {{ cantidad > 1 ? plan.unidadCantidadPlural : plan.unidadCantidadSingular }}
						</div>
					</div>
				</v-col>
				<v-col cols="12" :md="hayDatosAdicionales ? 4 : 6" class="d-flex justify-center align-center flex-column">
					<div class="py-1 text-center font-weight-black">
						Valor incorporación
					</div>
					<div class="py-1 text-center">
						$ {{ formatearMoneda(plan.valorIncorporacion*cantidad, plan.monedaValorIncorporacion) }} + IVA
					</div>
					<div class="py-1 text-center font-weight-black" v-if="mostrarDatosRenovacion(plan)">
						{{ plan.nombreRenovacion }} {{ plan.periodicidadRenovacion }}
					</div>
					<div class="py-1 text-center" v-if="mostrarDatosRenovacion(plan) && plan.monedaValorRenovacion==='UF'">
						{{ formatearMoneda(plan.valorRenovacion*cantidad, plan.monedaValorRenovacion) }} UF + IVA
					</div>
					<div class="py-1 text-center" v-else-if="mostrarDatosRenovacion(plan) && plan.monedaValorRenovacion==='CLP'">
						$ {{ formatearMoneda(plan.valorRenovacion*cantidad, plan.monedaValorRenovacion) }} + IVA
					</div>
					<div class="py-1 text-center" v-else-if="mostrarDatosRenovacion(plan)">
						{{ plan.valorRenovacion*cantidad }} {{plan.monedaValorRenovacion }} + IVA
					</div>
					<!-- v-else: no mostrar nada -->
				</v-col>
				<v-col cols="12" md="4" class="d-flex justify-center align-center flex-column" v-if="hayDatosAdicionales">
					<div class="py-1 text-center font-weight-black">
						Adicionales
					</div>
					<div class="py-1 text-center" v-for="datoAdicional in datosAdicionales">
						<b>{{ datoAdicional.adicional.nombre }}</b> x {{ datoAdicional.cantidad }}<br>
						<span v-if="datoAdicional.adicional.cantidadMaximaGratis">
							$ {{ formatearMoneda(datoAdicional.adicional.valor*
									Math.max(0, datoAdicional.cantidad - datoAdicional.adicional.cantidadMaximaGratis)) }} + IVA
							(hasta {{ datoAdicional.adicional.cantidadMaximaGratis }} gratis)
						</span>
						<span v-else>
							$ {{ formatearMoneda(datoAdicional.adicional.valor*datoAdicional.cantidad) }} + IVA
						</span>
					</div>
				</v-col>
			</v-row>
		</v-card>
		<v-card outlined color="grey lighten-4" class="pa-2 my-3" v-if="empresa !== undefined">
			<v-row dense>
				<v-col cols="12" class="title">
					Datos Empresa
					<v-btn @click="cambiarPaso(indicePasoCliente)" color="primary" fab x-small dark depressed>
						<v-icon>
							mode_edit
						</v-icon>
					</v-btn>
				</v-col>
				<v-col cols="12" sm="6">
					<b>Rut</b>: {{ empresa.rut }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>Razón social</b>: {{ empresa.razonSocial }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>Giro comercial</b>: {{ empresa.giroComercial }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>Nombre fantasía</b>: {{ empresa.nombreFantasia }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>Dirección comercial</b>: 
					{{ empresa.direccion }}, 
					{{ (empresa.comuna === undefined) ? undefined : empresa.comuna.nombre }}, 
					{{ (empresa.region === undefined) ? undefined : empresa.region.nombre }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>Teléfono</b>: {{ empresa.telefono }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>E-mail</b>: {{ empresa.email }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>¿Boleta electrónica activa?</b>: {{ empresa.tieneBoleta }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>Tipos de boleta</b>: {{ empresa.tiposBoleta }}
				</v-col>
			</v-row>
		</v-card>
		<v-card outlined color="grey lighten-4" class="pa-2 my-3" v-if="representante !== undefined">
			<v-row dense>
				<v-col cols="12" class="title">
					Datos Representante legal
					<v-btn @click="cambiarPaso(indicePasoCliente)" color="primary" fab x-small dark depressed>
						<v-icon>
							mode_edit
						</v-icon>
					</v-btn>
				</v-col>
				<v-col cols="12" sm="6">
					<b>Rut</b>: {{ representante.rut }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>Nombre completo</b>: {{ representante.nombres }} {{ representante.apellidoPaterno }} {{ representante.apellidoMaterno }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>E-mail</b>: {{ representante.email }}
				</v-col>
				<v-col cols="12" sm="6">
					<b>Teléfono</b>: {{ representante.telefono }}
				</v-col>
				<v-col cols="12" sm="6">
					<div>
						<b>Cédula Anverso</b>
					</div>
					<v-img :src="miniaturaCedulaAnverso" max-height="200" contain eager position="top left"/>
				</v-col>
				<v-col cols="12" sm="6">
					<div>
						<b>Cédula Reverso</b>
					</div>
					<v-img :src="miniaturaCedulaReverso" max-height="200" contain eager position="top left"/>
				</v-col>
			</v-row>
		</v-card>
		<v-card outlined color="grey lighten-4" class="pa-2 my-3" v-show="hayDirecciones">
			<v-row dense>
				<v-col cols="12" class="title">
					Direcciones
					<v-btn @click="cambiarPaso(indicePasoCliente)" color="primary" fab x-small dark depressed>
						<v-icon>
							mode_edit
						</v-icon>
					</v-btn>
				</v-col>
				<v-col cols="12" v-for="(direccion, indice) in direcciones">
					<b>Dirección #{{ indice + 1 }}</b>: 
					{{ direccion.direccion }}, 
					{{ (direccion.comuna === undefined) ? undefined : direccion.comuna.nombre }}, 
					{{ (direccion.region === undefined) ? undefined : direccion.region.nombre }}
				</v-col>
			</v-row>
		</v-card>
		<v-row>
			<v-col cols="12">
				<v-checkbox v-model="acepta" label="He revisado estos datos y son correctos" hide-details/>
			</v-col>
		</v-row>
	</v-template>
</template>

<script>
import numeral from 'numeral';
import * as imtool from 'imtool';

let contadorGeneracionMiniaturaCedulaAnverso = 0;
let contadorGeneracionMiniaturaCedulaReverso = 0;

export default {
	props: {
		'datos-plan': {
			type: Object,
			default: {},
		},
		'datos-cliente': {
			type: Object,
			default: {},
		},
		'datos-adicionales': {
			type: Object,
			default: {},
		},
		'indice-paso-plan': {
			type: Number,
		},
		'indice-paso-cliente': {
			type: Number,
		},
		'activo': {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		acepta: false,
		miniaturaCedulaAnverso: undefined,
		miniaturaCedulaReverso: undefined,
		cedulaAnversoDesactualizada: true,
		cedulaReversoDesactualizada: true,
	}),
	computed: {
		plan: function() {
			let vm = this;
			let datosPlan = vm.datosPlan;
			let plan = datosPlan.plan;
			return (plan === undefined) ? {} : plan;
		},
		cantidad: function() {
			let vm = this;
			return vm.datosPlan.cantidad;
		},
		empresa: function() {
			let vm = this;
			return vm.datosCliente.empresa;
		},
		representante: function() {
			let vm = this;
			return vm.datosCliente.representante;
		},
		direcciones: function() {
			let vm = this;
			let direcciones = vm.datosCliente.direcciones;
			return (direcciones === undefined) ? [] : direcciones;
		},
		hayDirecciones: function() {
			let vm = this;
			let direcciones = vm.direcciones;
			return (direcciones.length > 0);
		},
		hayDatosAdicionales: function() {
			let vm = this;
			let datosAdicionales = vm.datosAdicionales;
			let estaDefinido = (datosAdicionales !== undefined);
			if(!estaDefinido) {
				return false;
			}
			return (datosAdicionales.length > 0);
		},
	},
	methods: {
		mostrarDatosRenovacion: function(plan) {
			let hayValorRenovacion = !!plan.valorRenovacion;
			let codigoPlan = plan.codigo; // coberg 2023-06-14, ocultar datos si plan es anual
			let planEsAnual = /^.*ANUAL.*$/.test(codigoPlan);
			let mostrar = (hayValorRenovacion && !planEsAnual);
			return mostrar;
		},
		notificar: function(mensaje, tipo) {
			let vm = this;
			vm.$emit('notificacion', {mensaje, tipo});
		},
		emitirDatos: function(valido) {
			// valido proviene de watch acepta
			let vm = this;
			vm.$emit('datos', valido);
		},
		formatearMoneda: function(cifra, moneda='CLP') {
			let formateado;
			if(moneda === 'UF') {
				formateado = numeral(cifra).format('0,0[.][0000]'); // Precaución con más de 4 decimales
			}
			else {
				// Asumir CLP
				formateado = numeral(cifra).format();
			}
			return formateado;
		},
		cambiarPaso: function(indicePaso) {
			let vm = this;
			vm.$emit('cambio-paso', indicePaso);
		},
		generarMiniaturaCedulaAnverso: async function() {
			let vm = this;
			let identificadorInvocacion = ++contadorGeneracionMiniaturaCedulaAnverso;
			let representante = vm.representante;
			if((representante === undefined) || (representante.cedulaAnverso === undefined)
				|| (representante.cedulaAnverso === null)) {
				return undefined;
			}
			let file = vm.representante.cedulaAnverso;
			try {
		  	let tool = await imtool.fromImage(file);
		  	let cedulaAnversoDataUrl = await tool.thumbnail(250).toDataURL();
				if(identificadorInvocacion !== contadorGeneracionMiniaturaCedulaAnverso) { return; } // Inhibir.
		  	vm.miniaturaCedulaAnverso = cedulaAnversoDataUrl;
			}
			catch(e) {
				if(identificadorInvocacion !== contadorGeneracionMiniaturaCedulaAnverso) { return; } // Inhibir.
				vm.notificar('Error al generar miniatura del anverso de cédula', 'error');
			}
			vm.cedulaAnversoDesactualizada = false;
		},
		generarMiniaturaCedulaReverso: async function() {
			let vm = this;
			let identificadorInvocacion = ++contadorGeneracionMiniaturaCedulaReverso;
			let representante = vm.representante;
			if((representante === undefined) || (representante.cedulaReverso === undefined)
				|| (representante.cedulaReverso === null)) {
				return undefined;
			}
			let file = vm.representante.cedulaReverso;
			try {
		  	let tool = await imtool.fromImage(file);
		  	let cedulaReversoDataUrl = await tool.thumbnail(250).toDataURL();
				if(identificadorInvocacion !== contadorGeneracionMiniaturaCedulaReverso) { return; } // Inhibir.
		  	vm.miniaturaCedulaReverso = cedulaReversoDataUrl;
			}
			catch(e) {
				if(identificadorInvocacion !== contadorGeneracionMiniaturaCedulaReverso) { return; } // Inhibir.
				vm.notificar('Error al generar miniatura del reverso de cédula', 'error');
			}
			vm.cedulaReversoDesactualizada = false;
		},
	},
	watch: {
		datosCliente: {
			deep: true,
			immediate: true,
			handler: async function(newVal) {
				let vm = this;
				vm.acepta = false;
				vm.cedulaAnversoDesactualizada = true;
				vm.miniaturaCedulaAnverso = undefined;
				vm.cedulaReversoDesactualizada = true;
				vm.miniaturaCedulaReverso = undefined;
			},
		},
		datosPlan: {
			deep: true,
			immediate: true,
			handler: function(newVal) {
				let vm = this;
				vm.acepta = false;
			},
		},
		datosAdicionales: {
			deep: true,
			immediate: true,
			handler: function(newVal) {
				let vm = this;
				vm.acepta = false;
			},
		},
		acepta: function(newVal) {
			let vm = this;
			vm.emitirDatos(newVal);
		},
		activo: {
			immediate: true,
			handler: function(newVal) {
				let vm = this;
				if(newVal) {
					if(vm.cedulaAnversoDesactualizada) {
						vm.generarMiniaturaCedulaAnverso();
					}
					if(vm.cedulaReversoDesactualizada) {
						vm.generarMiniaturaCedulaReverso();
					}
				}
			}
		}
	},
};
</script>
